import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetDeviceLogPageable } from '../../../../reduxToolkit/Devices/DevicesApi';
import { logMessage } from '../../../../enums/logMessage';
import CustomModal from "../../../../components/Modal/CustomModal";
import CustomPagination from "../../../../components/table/CustomPagination";
import NotInformation from "../../../../components/NotInformation";
import {VIEW_TYPE} from "../../../../enums/ViewType";

const DeviceLogModal = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { getDeviceLogPageable } = useSelector((state) => state.DevicesSlice);
    const [view, setView] = useState(VIEW_TYPE.LIST.name);

    const { pagination, page, rowsPerPage } = CustomPagination({
        view,
        fixed:false,
        content:getDeviceLogPageable,
        labelRowsPerPage:"logs_per_page"
    });

    const uuid = props?.data?.id;

    useEffect(() => {

        const data = {
            id: uuid,
            body: {
                page: page,
                size: rowsPerPage,
            },
        };
        dispatch(GetDeviceLogPageable(data));
    }, [dispatch, page, rowsPerPage, uuid]);

    const getMessageDescription = (item) => {
        let actionDescription = '';

        const parts = item.message.split(',');
        const messageCode = parts[0].trim();
        const firstDetail = parts[1]?.trim() || '';
        const secondDetail = parts[2]?.trim() || '';

        switch (messageCode) {
            case '1':
                actionDescription = `${t('APP_CLOSED')}`;
                break;
            case '2':
                actionDescription = `${t('APP_STARTED')}`;
                break;
            case '40':
                actionDescription = `${t('new_IP')} ${firstDetail} ${t('or_MAC')} ${secondDetail} ${t(
                    'has_changed_verify',
                )}`;
                break;
            case '50':
                actionDescription = `${t('user_with_id:')} ${firstDetail} ${t('try_access')}`;
                break;
            case '51':
                actionDescription = `${t('user_with_id:')} ${firstDetail} ${t('access_waiting')}`;
                break;
            case '60':
                actionDescription = `${t('id:')} ${firstDetail} ${t('access_method_invalid')} ${secondDetail}`;
                break;
            case '101':
                actionDescription = `${t('FAR_ERROR_CONVERTING_SELFIE')} ${firstDetail}`;
                break;
            case '102':
                actionDescription = `${t('FAR_ERROR_CONVERTING_SELFIE_TO_IMAGE')} ${firstDetail}`;
                break;
            case '103':
                actionDescription = `${t('FAR_ERROR_CONVERTING_SELFIE_TO_BMP')} ${firstDetail}`;
                break;
            case '108':
                actionDescription = `${t('FAR_ERROR_VERY_HEAVY_IMAGE', { s: firstDetail })}`;
                break;
            case '109':
                actionDescription = `${t('FAR_ERROR_DECODE_BOUNDS', { s: firstDetail })}`;
                break;
            case '110':
                actionDescription = `${t('FAR_ERROR_COMPRESS_IMAGE', { s: firstDetail })}`;
                break;
            case '111':
                actionDescription = `${t('FAR_ERROR_OUT_OF_MEMORY', { s: firstDetail })}`;
                break;
            case '1000':
                actionDescription = `${t('error_syncing_device')}`;
                break;
            case '1001':
                actionDescription = `${t('device_synced_successfully')}`;
                break;
            case '1002':
                actionDescription = `${t('INFORMATION_SYNCHRONIZATION_INIT')}`;
                break;

            default:
                if (logMessage[messageCode]) {
                    actionDescription = t(logMessage[messageCode]);
                } else {
                    actionDescription = 'Message not found';
                }
                break;
        }

        return actionDescription;
    };

    return (

            <CustomModal
                {...props}
                title='device_log'
                size="lg"
                buttonConfirm="confirm"
                cancelButton={false}
                confirmButton={false}
                TablePagination={
                    pagination()
                }
                classNameBody="pt-2"
            >
                <div className='log-modal-body'>
                    {getDeviceLogPageable?.content?.length > 0 ?
                        getDeviceLogPageable?.content?.map((item) => (
                            <li key={item.id}>
                                    <span className='log-item-text'>
                                        {item.action}, {getMessageDescription(item)}
                                    </span>
                                <span className='log-item-date' style={{ float: 'right' }}>
                                                    {new Date(item.createdAt).toLocaleString('es-AR', {
                                                        hour12: false,
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        second: '2-digit',
                                                    })}
                                                </span>
                            </li>
                        )): <NotInformation text={t('no_information')} card={true}/>}
                </div>
            </CustomModal>
    );
};

export default DeviceLogModal;
